mutation NoteTravelerCreate($input: NoteTravelerCreateInput!) {
  noteTravelerCreate(input: $input) {
    note {
      id
      noteComment
      _rowTimestamp
      isShared
      entityId
    }
  }
}